export interface SaviezVousItem {
  id: string;
  text: string;
}

export const saviezVousData: SaviezVousItem[] = [
  {
    id: '1',
    text: "<strong>L'Algérie abrite le plus vaste ensemble d'art rupestre au monde.</strong>"
  },
  {
    id: '2',
    text: "<strong>95 % des Algériens vivent dans le nord, qui représente seulement 20 % du territoire.</strong>"
  },
  {
    id: '3',
    text: "<strong>L'Algérie est le 10ème plus grand pays au monde (plus grand méditerranéen, arabe et africain).</strong>"
  },
  {
    id: '4',
    text: "<strong>60 %de la population algérienne a moins de 30 ans</strong>."
  },
];

